export const REQUEST_NON_INVITED_MEMBERS = "request_non_invited_members"
export const SAVE_NON_INVITED_MEMBERS = "save_non_invited_members"
export const NON_INVITED_MEMBERS_FAILURE = "non_invited_members_failure"

export const CLEAR_NON_INVITED_MEMBER_STATE = "clear_non_invited_member_state"